<button (click)="button.action($event)">{{button.label}}</button>